export const PermissionHandler = (GlobalState, perm, type) => {
  const res = GlobalState?.Permission?.[perm];
  console.log(res, perm, type);

  return res?.includes(type);
  //   return true;
};
